require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-react-add-comments-in-jsx.json") })
        }
      }, "path---front-end-libraries-react-add-comments-in-jsx");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-react-add-comments-in-jsx!./.cache/json/front-end-libraries-react-add-comments-in-jsx.json
// module id = 2053
// module chunks = 231608221292675